import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-589198a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aigame-rank" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-rank-title" }, "排行榜", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-rank-subtitle" }, "榜单得分、排名信息每小时更新一次，此排行榜仅供参考不作为最终排名计算。", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_single_stage_rank = _resolveComponent("single-stage-rank")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2], (value, index) => {
      return _createVNode(_component_single_stage_rank, {
        key: index,
        step: value,
        pageSize: 10,
        showButton: true
      }, null, 8, ["step"])
    }), 64))
  ]))
}